module.exports = "<error-report ng-if=\"vm.areErrors\" type=\"access\" batch-id=\"vm.batchId\"></error-report>\n\n<batch-cancel ng-if=\"vm.isCancelable()\"  batch-id=\"vm.batchId\"></batch-cancel>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridErrorReportCell/tableGridErrorReportCell.html
// module id = 490
// module chunks = 1